import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import IdentityManager from "@arcgis/core/identity/IdentityManager";
import {AppConfiguration} from "./config/app-configuration";


export interface AuthenticationProps {
    appConfig: AppConfiguration;

    /**
     * Namspace legt fest, ob die Login-Session (Token) auch für andere Anwendungen verwendet werden darf.
     * Einen beliebigen String verwenden, um die Session für diese Anwendung einzuschränken.
     */
    appNamespace: string;
}

export class Authentication {
    appConfig: AppConfiguration;
    /**
     * Namspace legt fest, ob die Login-Session (Token) auch für andere Anwendungen verwendet werden darf.
     * Einen beliebigen String verwenden, um die Session für diese Anwendung einzuschränken.
     */
    appNamespace: string;
    oAuthInfo: OAuthInfo;

    constructor(props: AuthenticationProps) {
        if (props) {
            Object.assign(this, props);
        }
        this.oAuthInfo = this.initOAuth();
    }

    /**
     * Sharing endpoint of portal
     */
    get sharedPortalEndpoint(): string {
        return `${this.oAuthInfo.portalUrl}/sharing`;
    }

    /**
     * Login
     */
    login(): Promise<__esri.Credential> {
        return new Promise((resolve, reject) =>{
            IdentityManager.checkSignInStatus(this.sharedPortalEndpoint).then((credential: __esri.Credential) => {
                resolve(credential);
            }).catch(() => {
                reject("Error logging in.");
                // user will be redirected to OAuth sign-in page
                IdentityManager.getCredential(this.sharedPortalEndpoint);
            });
        });
    }

    logout(): void {
        IdentityManager.destroyCredentials();
    }

    initOAuth() {
        if (!this.appConfig.appId || !this.appConfig.portalUrl) {
            throw new Error("AppId or PortalUrl undefined.");
        }

        const oInfo = new OAuthInfo({
            // Use application ID of registered app
            appId: this.appConfig.appId,
            // use local portal
            portalUrl: this.appConfig.portalUrl,
            // Prevent the user's signed in state from being shared with other apps on the same domain
            // with the same authNamespace value.
            authNamespace: this.appNamespace,
            flowType: "auto", // default that uses two-step flow
            popup: false
        });
        IdentityManager.registerOAuthInfos([oInfo]);
        return oInfo;
    }
}
